import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import {Editor} from '../editor-components';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import './hall-list.css';

/** @class HallList
  * A component for listing halls to edit.
  */
export default class HallList extends Component {
  /** @constructor
    * Creates a new instance of HallList.
    */
  constructor(props) {
    super(props);
    this.state = {halls:[]}
    const expoID = this.props.match.params.expoID;
    const showID = this.props.match.params.showID;
    this.dataURL = `/expos/${expoID}/shows/${showID}/halls`;
    this.firebaseRef = firebase.database().ref(this.dataURL)
      .orderByChild('order');
    this.handleNewHall = this.handleNewHall.bind(this);
    this.handleCopyHall = this.handleCopyHall.bind(this);
    this.handleRemoveHall = this.handleRemoveHall.bind(this);
    this.toggleHallPublished = this.toggleHallPublished.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to the corresponding
    * firebase realtime database entry.
    */
  componentWillMount() {
    this.firebaseRef.on('value', snapshot => {
      var halls = [];
      snapshot.forEach((child) => {
        halls.push({
          id: child.key,
          data: child.val(),
          dataURL: `${this.dataURL}/${child.key}`
        });
      });
      this.setState({ halls: halls});
    });
    this.handleSortEnd = this.handleSortEnd.bind(this);
    this.handleNewHall = this.handleNewHall.bind(this);
    this.toggleHallPublished = this.toggleHallPublished.bind(this);
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database
    */
  componentWillUnmount() {
    this.firebaseRef.off();
  }
  /** @function handleSortEnd
    * Rearranges the hall list based on user changes.
    * @param {object} {oldIndex, newIndex} - the indices
    * of the halls to swap in the hall list.
    */
  handleSortEnd({oldIndex, newIndex}){
    var halls = arrayMove(this.state.halls, oldIndex, newIndex);
    var updates = {}
    halls.forEach((hall, i) => {
      if(hall.data.order !== i) {
        hall.data.order = i;
        updates[hall.dataURL] = hall.data;
      }
    });
    firebase.database().ref().update(updates);
  }
  /** @function handleNewHall
    * Creates a new hall in the firebase database.
    */
  handleNewHall(){
    const newHall = {
      name: "New Hall",
      stage: {
        width: 1024,
        height: 768,
        layers: []
      },
      order: this.state.halls.length
    };
    firebase.database().ref(this.dataURL).push(newHall);
  }
  /** @function handleCopyHall
    * Creates a copy of the specified hall.
    * @param {url} dataURL - the database url of
    * the specified hall.
    */
  handleCopyHall(dataURL) {
    firebase.database().ref(dataURL).once('value', snapshot=>{
      var hall = snapshot.val();
      hall.name = hall.name + " copy";
      hall.order = this.state.halls.length;
      firebase.database().ref(this.dataURL).push().set(hall);
    })
  }
  /** @function handleRemoveHall
    * Removes the hall from the firebase database
    * and any associated images from firebase storage
    * @param {string} dataURL - the url of the hall in firebase
    */
  handleRemoveHall(dataURL){
    firebase.database().ref(dataURL).remove();
    firebase.storage().ref().child(dataURL).delete();
  }
  /** @function toggleHallPublished
    * Toggles the published status of a hall
    * @param {integer} index - the index of the hall
    * to update in the hall list.
    */
  toggleHallPublished(index) {
    var hall = this.state.halls[index];
    hall.data.published = !hall.data.published;
    firebase.database().ref(hall.dataURL).set(hall.data);
  }
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <Editor>
        <label>Halls</label>
        <SortableList
          items={this.state.halls}
          useDragHandle={true}
          onSortEnd={this.handleSortEnd}
          onToggleHallPublished={this.toggleHallPublished}
          onCopyHall={this.handleCopyHall}
          onRemoveHall={this.handleRemoveHall}
          />
        <button onClick={this.handleNewHall}>
          <FontAwesome name="plus"/>
          New Hall
        </button>
      </Editor>
    );
  }
}

/* A Drag handle for the sortable list */
const DragHandle = SortableHandle(() => <FontAwesome name="reorder"/>);

/* An item in the sortable list */
const SortableListItem = SortableElement((props) => {
  return(
    <div className="hall-list-item">
      <span>
        <DragHandle />
      </span>
      <span>
        {props.hall.data.name}
      </span>
      <span>
        <FontAwesome name={props.hall.data.published?'flag':'ban'}
          style={{color: "#4eba6f", cursor: "pointer"}}
          onClick={props.onToggleHallPublished}
          />
        <Link to={props.hall.dataURL}>
          <FontAwesome name="edit"
            style={{color:"#965ba5",cursor: "pointer"}}
            />
        </Link>
        <FontAwesome name="copy"
          style={{color:"#f0c419",cursor: "pointer"}}
          onClick={props.onCopyHall}
          />
        <FontAwesome name="times"
          style={{color: "red", cursor: "pointer"}}
          onClick={props.onRemoveHall}
          />
      </span>
    </div>
  );
});

/* The sortable list */
const SortableList = SortableContainer((props) => {
  return (
    <div className="hall-list">
      {props.items.map((hall, index) => (
        <SortableListItem
          key={`hall-${hall.id}`}
          index={index}
          hall={hall}
          onToggleHallPublished={()=>{props.onToggleHallPublished(index)}}
          onCopyHall={()=>{props.onCopyHall(hall.dataURL)}}
          onRemoveHall={()=>{props.onRemoveHall(hall.dataURL)}}
          />
      ))}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/hall-list/hall-list.js